import React from 'react';
import { Link } from 'react-router-dom';
import SectionContainer from '../containers/SectionContainer';
import './Song.css';
import NavLinkToggle from './NavLinkToggle';

export default function Song(props) {
  return (
    <div className="paper-shadow bg-white py-3 px-3 mb-3">
      <NavLinkToggle
        to={props.location.pathname === '/meta' ? '/' : '/meta'}
        className="wholesong-meta selectable p-2"
        activeClassName="selected"
        location={props.location}
      >
        <h4 className="text-center px-4">{props.song.meta.title || 'New Song'}</h4>
        <p className="text-center px-2" style={{ position: 'relative' }}>
          {props.song.meta.authors && (
            <span className="mx-2">
              By <b>{props.song.meta.authors}</b>
            </span>
          )}
          {props.song.meta.key && (
            <span style={{ position: 'absolute', right: 0 }}>
              Key: <b>{props.song.meta.key}</b>
            </span>
          )}
          <br />
        </p>
      </NavLinkToggle>
      <div className="list-group">
        {props.song.structure.map((sectionId, index) => (
          <SectionContainer
            key={`${index}-${sectionId}`}
            id={sectionId}
            section={props.song.sections.byId[sectionId]}
            location={props.location}
            sectionIndex={index}
          />
        ))}
      </div>
      <div className="text-center border-top pt-3">
        <Link to="/section/add" className="btn btn-outline-info">
          Add Section
        </Link>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Song.js